<ndw-layout
  [applicationName]="applicationName"
  brand="NDW"
  [topMenuItems]="menuService.topMenuItems()"
  [bottomMenuItems]="menuService.bottomMenuItems()"
  [menuFooterTexts]="footerTexts"
  [isCollapsible]="true"
  [isExpanded]="false"
  [version]="'Versie ' + buildNumber"
  (click)="onMenuClick($event)"
>
  <ndw-layout-banners>
    @for (banner of bannerService.banners(); track banner.id) {
      <ndw-banner
        [title]="banner.title"
        [message]="banner.message"
        [type]="banner.type"
        (close)="bannerService.closeBanner(banner.id)"
      />
    }
    @for (banner of bannerService.infoMessageBanners(); track banner.id) {
      @if (!banner.deleted) {
        <ndw-banner
          [title]="banner.title"
          [message]="banner.message"
          [type]="banner.type"
          (close)="bannerService.closeInfoMessage(banner.id)"
        />
      }
    }
  </ndw-layout-banners>
  <app-release-notes-popup></app-release-notes-popup>

  <router-outlet />
</ndw-layout>
